export const FIELD_TYPES = {
  DATEPICKER: 'datepicker',
  SELECT: 'select',
  INPUT: 'input',
};

export const TEXT_TYPES = {
  EMAIL: 'email',
  TEXT: 'text',
  NUMBER: 'number',
};

export const PHONE_NUMBER_PLACEHOLDER = '{nomer}';
